export default "__VITE_ASSET__DyZO7jmC__"